import { PmErrorState } from "./PmErrorState";

export const ResourceError = (props) => {
  const { errors, onRetry, retryLabel, subtitle, variant, backTo, layout } = props;
  const errorMessages = errors
    ? Array.isArray(errors)
      ? errors
      : [errors]
    : [];

  return (
    <PmErrorState
      variant={variant || "load_error"}
      layout={layout || "module"}
      description={subtitle}
      details={errorMessages}
      onRetry={onRetry}
      retryLabel={retryLabel}
      backTo={backTo}
    />
  );
};
